<!-- <div [class.loader-hidden]="false"> -->
<div *ngIf="show" class="mainSpinner">
    <div class="loader-overlay">
        <div>
            <mat-progress-bar mode="indeterminate" *ngIf="true"></mat-progress-bar>
        </div>
    </div>
</div>
